import React from "react";
import { LinkButton } from "./linkButton";
import { IconButton } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

type EditButtonProps = {
  to: string;
};

export function View({ to }: EditButtonProps) {
  return (
    <LinkButton to={`${to}`} title={"Ver"}>
      <IconButton>
        <RemoveRedEyeOutlinedIcon color="secondary" />
      </IconButton>
    </LinkButton>
  );
}
